const getOperatorIsLoggingIn = (state) => {
  return state.operatorIsLoggingIn;
};

export { getOperatorIsLoggingIn };
